// @flow
export const ContactPageLocale = {
  header: {
    title: ["Contact Us", "Bize Ulaşın"],
    content: [
      "If you have any questions or remarks you can reach us at any time of day via the below methods.",
      "Sorularınız veya merak ettikleriniz için bize günün her saati aşağıdaki yöntemlerle ulaşabilirsiniz.",
    ],
  },
  contact_unit: {
    title: ["Contact Methods", "Bize Ulaşmanın Yolları"],
    form_area: {
      success_message: [
        "We received your message and will contact you soon.",
        "Mesajınız tarafımıza ulaştı, en kısa zamanda size geri dönüş sağlayacağız.",
      ],
      failure_message: [
        "Please check all the fields and submit again.",
        "Lütfen formdaki alanları kontrol edip mesajınızı tekrar gönderin.",
      ],
      first_name: ["First Name", "Adınız"],
      last_name: ["Last Name", "Soyadınız"],
      email: ["Email Address", "Eposta Adresiniz"],
      phone: ["Contact Number", "İletişim Numarası"],
      message: ["Write your message here...", "Mesajınızı buraya yazın..."],
      form_submit: ["Send Message", "Mesajı Gönder"],
    },
  },
  information_unit: {
    address: {
      header: ["Operation Office", "Operasyon Ofisi"],
      content: [
        "Kozyatağı Kaya Sultan Sokağı No:77/13 Sembol İş Merkezi, ",
        "Kozyatağı Kaya Sultan Sokağı No:77/13 Sembol İş Merkezi",
      ],
      subcontent: ["Kadıköy, İstanbul, Turkey", "Kadıköy, İstanbul, Türkiye"],
      email: ["iletisim@envanterium.com", "iletisim@envanterium.com"],
    },
  },
  map_unit: {
    location: {
      lat: ["40.983617", "40.983617"],
      long: ["29.039741", "29.039741"],
    },
    title: ["Operation Office", "Operasyon Ofisi"],
  },
};



// WEBPACK FOOTER //
// ./src/Locales/PublicPages/ContactPage.locale.js